import { IWPLink } from "@/src/types";
import React from "react";
import S from "./LinksNavigation.styled";
import { MainSection } from "@/styles/global";
import { getBgColor } from "@/src/helpers";
import Arrow from "assets/arrow.svg";

export interface LinksNavigationProps {
  title: string;
  navLinks: {
    link: IWPLink;
  }[];
}

const LinksNavigation: React.FC<LinksNavigationProps> = ({
  title,
  navLinks,
}) => {
  const renderLinks = navLinks?.map(({ link }, index) => {
    return (
      <S.LinkItem key={index}>
        <S.Link to={link.url} target={link.target}>
          {link.title}
        </S.Link>
        <Arrow />
      </S.LinkItem>
    );
  });

  return (
    <MainSection $bgColor={getBgColor("dark", "purple")}>
      <S.Inner>
        <S.Title>{title}</S.Title>
        <S.LinksWrapper>{renderLinks}</S.LinksWrapper>
      </S.Inner>
    </MainSection>
  );
};

export default LinksNavigation;
